import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';

export const Loader = styled.div`
  color: ${colors.red};
  padding: 1.875rem 0 3.3125rem;
  text-align: center;

  ${media.w.min.px576(css`
    padding-top: 3.375rem;
  `)};
`;

export const ListingResults = styled.div`
  ${media.w.min.px576(css`
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(auto-fill, 13.25rem);
  `)};

  ${media.w.min.px768(css`
    padding: 0 1.5rem;
  `)};

  ${media.w.min.px992(css`
    padding: 0;
  `)};
`;

export const ListingItem = styled.div`
  margin-bottom: 1.5rem;
  display: flex;

  ${media.w.min.px576(css`
    margin-bottom: 0;
  `)};
`;
